import Vue from "vue";
import VueRouter from "vue-router";
import Index from "@/view/index/index";
import store from "@/store/index";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
    component: Index,
  },

  // 首页展示
  {
    path: "/index",
    name: "Index",
    component: () => import("@/view/index/index"),
  },
  // 关于我们
  {
    path: "/about",
    name: "about",
    component: () => import("@/view/about/about.vue"),
  },
  // 线束加工
  {
    path: "/harness",
    name: "harness",
    component: () => import("@/view/harness/harness.vue"),
  },
  // PCBA加工
  {
    path: "/pcba",
    name: "pcba",
    component: () => import("@/view/pcba/pcba.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base:
    process.env.NODE_ENV === "production" || process.env.NODE_ENV === "dev"
      ? "/jddqui/"
      : "/",
  routes,
});

router.beforeEach((to, from, next) => {
  // 如果页面需要验证登录
  if (to.meta.requireAuth) {
    if (store.getters.systemUser) {
      // let userId = store.getters.systemUser.userId;
      // let token = store.getters.systemUser.tokenStatus.token;
      // checkTokenMethod(userId, token).then((res) => {
      //   if (res) {
      //     next();
      //   } else {
      //     router.push("/login");
      //   }
      // });
    } else {
      //直接跳转登录界面，参数带上
      // router.push("/login");
    }
  } else {
    next();
  }
});

export default router;
